export default __webpack_public_path__ + "static/media/dashboard_icon.d2eb13b7.svg";